import { action } from 'typesafe-actions';

import ActionTypes from './constants';

const setTime = (time: number) => action(ActionTypes.SET_TIME, time);

export default setTime;
